<div [class]="'atp-dynamic-form__container'" style="display: flex; flex-direction: column;padding:0px">
  <div class="atp-dynamic-form__inner">
    <atp-title class="atp-dynamic-form__title" [text]="'Чат'" notSetInHeader="false"></atp-title>
    <div class="atp-dynamic-form__messages" #messagesOut>
      <div *ngFor="let message of messages;let i=index;" [ngClass]="{'ng-star-inserted-you':message.userId==userId}">
        <div class="atp-chat-message">
          <div class="atp-chat-message__inner">
            <div class="atp-chat-message__text">{{message.text}}</div>
            <div class="atp-chat-info">
              <div class="atp-chat-info__user">{{message.user}}</div>
              <div class="atp-chat-datetime">
                <div class="atp-chat-datetime__date">
                  {{processingDate(message.createdDate)}}
                </div>
                <div class="atp-chat-datetime__time">
                  {{processingTime(message.createdDate)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="atp-dynamic-form__submit">
      <div>
        <form class="atp-dynamic-form__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
          <textarea class="atp-dynamic-form__textarea" name="message" formControlName="message" [required]="true"
            placeholder="Введите сообщение..." #messagesOut></textarea>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="atp-dynamic-form__button" (click)="submit()">
            <path
              d="M2.06075 0.97107L24.6357 11.7679C24.8639 11.8768 25.0566 12.0481 25.1915 12.262C25.3264 12.4759 25.3979 12.7236 25.3979 12.9764C25.3979 13.2293 25.3264 13.477 25.1915 13.6908C25.0566 13.9047 24.8639 14.076 24.6357 14.185L2.06075 24.9818C1.82932 25.0926 1.57092 25.1347 1.3163 25.1029C1.06167 25.0711 0.821535 24.9668 0.624463 24.8025C0.427391 24.6381 0.281678 24.4207 0.204662 24.1759C0.127645 23.9311 0.122568 23.6694 0.190033 23.4218L2.4486 15.1418C2.47625 15.0403 2.53316 14.9492 2.61223 14.8799C2.6913 14.8105 2.78903 14.766 2.89325 14.7518L13.8325 13.2657C13.8783 13.2592 13.9215 13.241 13.9581 13.2128C13.9947 13.1847 14.0234 13.1475 14.0415 13.105L14.0607 13.0386C14.0692 12.9788 14.0572 12.9178 14.0266 12.8657C13.9961 12.8136 13.9488 12.7733 13.8925 12.7514L13.8336 12.7354L2.90503 11.2493C2.80101 11.2349 2.70351 11.1903 2.62464 11.1209C2.54578 11.0516 2.48904 10.9606 2.46146 10.8593L0.190033 2.53214C0.122294 2.2845 0.127165 2.0226 0.204066 1.77764C0.280966 1.53269 0.426655 1.315 0.623779 1.1505C0.820904 0.986002 1.06116 0.881633 1.31592 0.849822C1.57069 0.81801 1.82923 0.860097 2.06075 0.97107Z"
              fill="#3E51AF" />
          </svg>

        </form>
      </div>
    </div>
  </div>
</div>